export {
  COMMON_FONTS,
  FONT_CONFIG,
  FONT_CONFIG_FIXED
} from "./font";
